/**
 * GuidedChips — Contextual prompt suggestions rendered above the input.
 * Chips are driven by DSR gaps and completeness score via DealContext.
 */

import type { PromptChip } from "@/schemas/deals";

const CATEGORY_COLORS: Record<string, string> = {
  discovery: "var(--accent)",
  analysis: "var(--warning)",
  synthesis: "var(--success)",
};

interface GuidedChipsProps {
  chips: PromptChip[];
  onChipClick: (message: string) => void;
  disabled?: boolean;
}

export default function GuidedChips({ chips, onChipClick, disabled }: GuidedChipsProps) {
  if (chips.length === 0) return null;

  return (
    <div className="guided-chips">
      {chips.map((chip) => (
        <button
          key={chip.label}
          className="chip-btn"
          disabled={disabled}
          onClick={() => onChipClick(chip.message)}
          style={{
            borderColor: CATEGORY_COLORS[chip.category] || "var(--border)",
          }}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
